import React, { useCallback } from 'react';

import { Control, UseFormWatch } from 'react-hook-form';
import CheckboxHF from 'common/components/FormHF/CheckboxHF';
import type { UseFormSetValue } from 'react-hook-form/dist/types/form';
import { FallbackFormValues } from 'utils/type-tools';
import { IFormValues } from 'common/components/FormHF/types';
import { ARGProjectFields } from '@arg,@demo,@greenline/containers/project-fields';
import styles from './styles.module.scss';


interface IProps<TFormValues extends FallbackFormValues> {
    className?: string,
    control: Control<TFormValues>
    setValue: UseFormSetValue<TFormValues>,
    watch: UseFormWatch<TFormValues>,
    disabled?: boolean,
}

// eslint-disable-next-line
const text = 'Using these products involves risks; ensure proper safety precautions for your application. Improper use may result in damage, injury, or death. Verify component specifications before purchasing. Custom assemblies are non-returnable and non-refundable. By checking this box, you acknowledge and accept these terms.';

export const TosCheckboxConnected = ({
  watch, className, control, setValue, disabled,
}: IProps<IFormValues<ARGProjectFields>>) => {
  const value = watch('tosAgreed' as any);

  const handleSetCounter = useCallback((fieldName: string) => {
    setValue(fieldName as ARGProjectFields, !value as unknown as number);
  }, [setValue, value]);

  return (
    <CheckboxHF
      control={control}
      name="tosAgreed"
      className={className}
      value="tosAgreed"
      onChangeHandler={disabled ? undefined : handleSetCounter}
      disabled={disabled}
      description={text}
    >
      Accept
      <span className={styles.required}>*</span>
    </CheckboxHF>
  );
};

export default TosCheckboxConnected;
